import React, { useEffect, useRef, FC } from 'react';
import { PopupProps } from './Popup.types';
import { StyledPopupDiv } from './Popup.styles';

const Popup: FC<PopupProps> = ({
  className,
  show,
  children,
  handleBlur,
  popupOpenState,
  setPopupOpenState,
  triggerRef,
  role,
  labelledBy,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (handleBlur && popupOpenState && setPopupOpenState) {
      const popupElem = popupRef.current;
      if (popupElem && popupOpenState) {
        const mousedownListener = (event: MouseEvent): void => {
          const target = event.target as Node;
          const clickedInsidePopup = popupElem.contains(target);
          const clickedTrigger = Boolean(triggerRef?.current?.contains(target));

          if (!clickedInsidePopup && !clickedTrigger) {
            setPopupOpenState(false);
          }
        };

        const focusoutListener = (event: FocusEvent): void => {
          const nextFocusedElement = event.relatedTarget as Node | null;

          if (
            nextFocusedElement &&
            !popupElem.contains(nextFocusedElement) &&
            !triggerRef?.current?.contains(nextFocusedElement)
          ) {
            setPopupOpenState(false);
          }
        };

        document.addEventListener('mousedown', mousedownListener);
        popupElem.addEventListener('focusout', focusoutListener);

        return (): void => {
          document.removeEventListener('mousedown', mousedownListener);
          popupElem.removeEventListener('focusout', focusoutListener);
        };
      }
    }
    return;
  }, [handleBlur, popupOpenState, setPopupOpenState, triggerRef]);

  return (
    <StyledPopupDiv className={className} show={show} ref={popupRef} role={role} aria-labelledby={labelledBy}>
      {children}
    </StyledPopupDiv>
  );
};

export default Popup;
